import { FixedLayer } from './fixed-layer';
import { BaseComponent } from '../../base-component';
import { encodeHtml, encodeHtmlTag } from '../../_common/client/encode-html';
import { ProviderService } from './provider-service';

export class ManufacturerContentBtnComponent extends BaseComponent {
    public rootSelector = '.js_pdp_manufacturer-content-btn';

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) {
            return;
        }
        this.registerClickHandler();
    }

    private registerClickHandler(): void {
        const buttonElement = this.getRootElement();
        buttonElement?.addEventListener('click', () => this.clickListener(buttonElement), false);
    }

    private async clickListener(buttonElement: HTMLElement): Promise<void> {
        const brandName = buttonElement.getAttribute('data-brand-name');
        const headlineContent = encodeHtmlTag`Weitere Artikelinformationen von ${brandName}`;
        const bodyContent = '<div class="p_loader200">Wird geladen...</div>';

        const layer = new FixedLayer(headlineContent, bodyContent, () => this.closeLayerCallback());
        try {
            const providerName = encodeHtml(buttonElement.getAttribute('data-provider-name'));
            const ean = encodeHtml(buttonElement.getAttribute('data-ean'));
            let iframeSource = '';
            iframeSource = await ProviderService.getIframeSource(providerName, ean);
            layer.setBodyContent(this.createWrappedIframeElement(iframeSource));
        } catch (error) {
            const errorMessageHtml =
                '<div class="p_message p_message--error"><b>Entschuldigung!</b> Aufgrund von ' +
                'technischen Problemen kann der Inhalt leider nicht geladen werden. Bitte versuche es zu einem ' +
                'späteren Zeitpunkt erneut.</div>';

            layer.setBodyContent(errorMessageHtml);

            this.trackEvent({
                product_BrandContent: error,
            });
        }
    }

    private closeLayerCallback(): void {
        this.trackEvent({
            product_BrandContent: 'close',
        });
    }

    private createWrappedIframeElement(iframeSource: string): HTMLElement {
        const wrapperElement = document.createElement('td');
        const iframeWrapperWrapperElement = document.createElement('div');
        const iframeWrapperElement = document.createElement('div');
        const iframeElement = document.createElement('iframe');

        iframeWrapperWrapperElement.className = 'pdp_manufacturer-content-layer-body__iframe-wrapper-wrapper';
        iframeWrapperElement.className = 'pdp_manufacturer-content-layer-body__iframe-wrapper';
        iframeElement.className = 'pdp_manufacturer-content-layer-body__iframe';
        iframeElement.onload = () => this.iframeLoadEventListener();
        iframeElement.src = iframeSource;

        iframeWrapperWrapperElement.appendChild(iframeWrapperElement);
        iframeWrapperElement.appendChild(iframeElement);
        wrapperElement.appendChild(iframeWrapperWrapperElement);

        return wrapperElement;
    }

    private iframeLoadEventListener() {
        this.trackEvent({
            product_BrandContent: 'load',
        });
    }
}
